import React from 'react';
import { withPermissions } from './withPermissions';

class OCComponent<P> extends React.Component<P> {
	// interface AllowActions
	render() {
		return this.props.children;
	}
}

export const WithAuth = withPermissions(OCComponent);
